// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"130": "enterprises","141": "confirmation","171": "react-query-devtools","308": "phoneInput","403": "intl-pluralrules","478": "intl-numberformat","61": "rates","618": "intl-locale","896": "icons","914": "summary","919": "pictograms","95": "dates","972": "spaceCategories",}[chunkId] || chunkId) + ".js"
}